import React, { useRef, useEffect } from 'react'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import PropTypes from "prop-types";
import styled from 'styled-components';


const BarContainer = styled.div`
  height: 500px;
  min-height: 100%;
  width: '100%';
  @media (min-width: 1200px) {
    height: "300px";
    min-height: 100%;
    width: '100%';
  }
`

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ChartDataLabels,
  Title,
  Tooltip,
  Legend
);



function GroupedBarGraph({ options, data, legends }) {
  const chartRef = useRef(null);
  useEffect(() => {
    const chart = chartRef.current;
    window.addEventListener('resize', () => {
  
      if (window.innerWidth < 1400) {
        chart.config.options.plugins.legend.labels.font.size = 16;
        chart.config.options.plugins.legend.position= 'bottom';
        chart.config.options.plugins.legend.align= 'start';
      } else {
        chart.config.options.plugins.legend.labels.font.size = 18;
        chart.config.options.plugins.legend.position= 'right';
        chart.config.options.plugins.legend.align= 'center';
      }
    });
  }, []);
  return (
    <BarContainer>
      <Bar
        ref={chartRef}
        options={options}
        data={data}
      />
      {legends}
    </BarContainer>
  )
}


GroupedBarGraph.propTypes = {
  data: PropTypes.shape({}),
  options: PropTypes.shape({}),
  legends: PropTypes.node,
};

GroupedBarGraph.defaultProps = {
  data: undefined,
  options: undefined,
  legends: undefined
}
export default GroupedBarGraph